import { Component,  OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MobileEcatalogService } from "../mobile-ecatalog.service"
@Component({
  selector: 'app-mobile-company-search',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.less']
})
export class ProductCompanySearchComponent implements OnInit {

  isSearchSuccess: boolean = false;
  codeSearchValue: string = '';
  storageVinList: any[] = [];

  constructor(
    public router: Router, 
    private mobileProductService: MobileEcatalogService
  ) { 
    
  }

  ngOnInit(): void {
    const storageVins = localStorage.getItem('mobileCompanySearch');
    this.storageVinList = storageVins ? JSON.parse(storageVins) : [];
  }
  ngOnDestroy() {
    
  }
  clearVehiclesVin(){
    this.isSearchSuccess = false;
    this.codeSearchValue = "";
  }

  queryVehiclesByCode():void {
    this.storageVinList = [...new Set([...this.storageVinList, this.codeSearchValue].filter(i=> (!!i)))]
    localStorage.setItem('mobileCompanySearch', JSON.stringify(this.storageVinList))

    const country = localStorage.getItem("country");
    this.mobileProductService.sendVehicleParams({
        vehicle: this.codeSearchValue,
        product: this.codeSearchValue,
        vin: '',
        isMobile: true,
        type: 'product',
        tabIndex: 2
    })
    this.router.navigate(
      [
        `${country}/ecatalog`,
      ],
    );
  }

  handleClearSearchStorage(){
    localStorage.removeItem('mobileCompanySearch');
    this.storageVinList = [];
  }

  handleSelectStorageItem(code: string){
    this.codeSearchValue = code
    this.queryVehiclesByCode()
  }
}
